const news = () => {
    let pathname = window.location.pathname
    if(['/tin-tuc/tuyen-dung', '/en/news/recruitment'].includes(pathname)) {
        $('html,body').animate({
            scrollTop: $('#recruitment').offset().top - 159
        }, 800);
    }
}

module.exports = news
